module.exports = __webpack_public_path__ + "js/0.b4e18fde.worker.js"